// Live video media-plane config (PRD-0010).
//
// Read entirely from the environment, the same discipline as auth/config.ts and
// realtime/config.ts: when it is absent, video is ABSENT — the teleop view shows
// its honest empty state naming the missing piece, never a placeholder feed.
//
// Note what is NOT here: no stage ARN, no region, no endpoint. The browser is
// handed a participant token by the API and nothing else; the stage it belongs
// to is resolved server-side and is deliberately not an identifier the client
// gets to supply or trust (PRD-0010 C3).

export interface MediaConfig {
  /** Purely for display — "which media plane am I on" in the chrome. */
  readonly label: string;
}

export function mediaConfig(): MediaConfig | null {
  const enabled = import.meta.env.VITE_VIDEO_ENABLED as string | undefined;
  if (!enabled || enabled === '0' || enabled === 'false') return null;
  return { label: (import.meta.env.VITE_VIDEO_LABEL as string) || 'IVS Real-Time' };
}

/** The codec PRD-0010 D6 pins end to end. A fact, not a reading. */
export const CODEC = 'H.264';

/** How often the console asserts "someone is still watching" (D15). */
export const HEARTBEAT_PERIOD_MS = 15_000;

/** Ask the server to renew the token when this little is left on it (D18). */
export const RENEW_BELOW_S = 300;

/** How often WebRTC stats are polled for the instruments. */
export const STATS_PERIOD_MS = 2_000;
